/**
 * The group pop-up's list (19/10/2026): loading, error, the filter's empty
 * state in words, or the rows — today's set with the "Today" badge.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Check } from 'lucide-react';

import type { ScopedList } from './list-scope';
import { listName } from './today-list-order';

interface Props {
  state: { isLoading: boolean; isError: boolean; refetch: () => unknown };
  rows: ScopedList[];
  empty: string;
}

const Row: FC<{ list: ScopedList }> = ({ list }) => (
  <li className={`flex min-w-0 items-center gap-2 px-3 py-2 text-sm ${list.today ? 'bg-primary/5' : ''}`}>
    <span className="min-w-0 flex-1 truncate font-mono text-xs" title={listName(list)}>
      {listName(list)}
    </span>
    {list.today ? (
      <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-semibold text-primary">
        <Check className="h-3 w-3" /> Today
      </span>
    ) : null}
    {list.leadCount != null ? (
      <span className="shrink-0 font-mono text-[10px] tabular-nums text-muted-foreground" title={`${list.leadCount.toLocaleString('en-US')} leads`}>
        {list.leadCount.toLocaleString('en-US')}
      </span>
    ) : null}
  </li>
);

export const GroupListRows: FC<Props> = ({ state, rows, empty }) => {
  if (state.isLoading)
    return (
      <div className="space-y-2 p-3" aria-label="Loading lists">
        {[0, 1, 2, 3].map((i) => <div key={i} className="h-6 animate-pulse rounded bg-muted/70" />)}
      </div>
    );
  if (state.isError)
    return (
      <div className="p-3 text-sm text-muted-foreground">
        Could not load this group&apos;s lists.
        <button type="button" onClick={() => state.refetch()} className="ml-1 font-medium text-primary hover:underline">Retry</button>
      </div>
    );
  if (!rows.length) return <p className="p-3 text-sm text-muted-foreground">{empty}</p>;
  return (
    <ul className="divide-y divide-border/50">
      {rows.map((list) => <Row key={list.wiserId} list={list} />)}
    </ul>
  );
};
